/**
 * NWS_SMILELINE-1962: 本文の「メディアの挿入」のファイルボタンで受け付ける動画（mp4・mov）
 * 画像の挿入は従来どおり画像だけ。ここは動画だけを扱う。
 */
export const EDITOR_VIDEO_ACCEPT = 'video/mp4,video/quicktime,.mp4,.mov'
export const EDITOR_VIDEO_KIND = 'video'

const EDITOR_VIDEO_EXTENSIONS = ['mp4', 'mov']
const EDITOR_VIDEO_MIME_TYPES = ['video/mp4', 'video/quicktime']

/**
 * mp4・mov か。Windows などで種類（type）が空になることがあるため、拡張子を主に見る。
 * 中身の判定はサーバー（API）でも行う。
 */
export function isEditorVideo(file: File): boolean {
  const extension = (file.name.split('.').pop() || '').toLowerCase()
  if (!EDITOR_VIDEO_EXTENSIONS.includes(extension)) return false
  return file.type === '' || EDITOR_VIDEO_MIME_TYPES.includes(file.type)
}

/** 上限（バイト）以下か。サーバーと同じく、ちょうど上限は通す */
export function isWithinVideoMaxSize(file: File, maxBytes: number): boolean {
  return file.size <= maxBytes
}
